import React, { FunctionComponent, useCallback } from 'react';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';

export const TaskDragDropContext: FunctionComponent = ({ children }) => {
  const handleDrop = useCallback((result: DropResult) => {
    // dispatch(updateTask, {
    //   propertyTargets: {
    //     propertyTarget: newValue,
    //     propertyTarget: newValue...
    //   }
    //   taskId: ...
    // });
  }, []);

  return <DragDropContext onDragEnd={handleDrop}>{children}</DragDropContext>;
};
